export const PERSONAL_INFORMATION = {
  INTERESTED_AREA: 0,
  INTERESTED_SECTOR: 1,
  SPECIFIC_FUNDS: 2,
  SPECIFIC_BENCHMARKS: 3,
  SPECIFIC_ISSUES: 4,
  ASSET_CLASSES: 5
}

export const APPLICATION_BEHAVIOUR = {
  ADD_APPLICATIONS: 0,
  RECENTLY_OPENED_APPS: 1,
  FAVOURITE_APPS: 2
}

export const APPLICATION_STATUS = {
  OLD: 0,
  NEW: 1
}
